const zIndex = {
  // required so that the Google Map doesn't overlay the mobile nav when the latter is open
  styledGoogleMap: -1,
  // required so that the Google Map doesn't overlay the site header
  styledHeader: 1,
}

export {zIndex}
